import HandIcon from 'assets/images/easyPay/hand.svg'
import Header from 'components/headers/withGreenBack'
import DotsLoading from 'components/loadings/dotsLoading'
import Footer from 'modules/easyPay/footer'
import useSetTotalPayment from 'modules/easyPay/hooks/useSetTotalPayment'
import Item from 'modules/easyPay/item'
import useGetBoxGroupAllPayment from './hooks/useGetBoxGroupAllPayment'

export default function InitMoneyPool() {
    const {
        payments,
        isLoading,
        handleSelectAllPayments,
        isAllSelected,
        handleSelectSpecificPayment,
    } = useGetBoxGroupAllPayment(false)
    const { total, commission } = useSetTotalPayment(payments)
    return (
        <>
            {isLoading ? (
                <DotsLoading />
            ) : (
                <div className="flex flex-col relative min-h-screen h-screen">
                    <div className="grow-0">
                        <Header title="پرداخت آسان" />
                    </div>
                    <div className="grow">
                        <img
                            src={HandIcon}
                            alt="hand"
                            className=" mx-auto -mb-24 z-50 mt-6"
                        />
                        <div className="  bg-white shadow-soft rounded-xl px-3 pt-3 pb-8 mx-4 mt-16 sm:max-h-[390px] md:max-h-[300px] overflow-y-auto ">
                            <div className=" flex justify-between mt-4">
                                <p className="">انتخاب همه</p>
                                <input
                                    type="checkbox"
                                    checked={isAllSelected}
                                    onChange={handleSelectAllPayments}
                                    className=" cursor-pointer"
                                />
                            </div>
                            {payments &&
                                payments?.map((item) => (
                                    <Item
                                        key={item.id}
                                        item={item}
                                        isSelected={item.isSelected}
                                        handleSelectSpecificPayment={
                                            handleSelectSpecificPayment
                                        }
                                    />
                                ))}
                        </div>
                    </div>
                    <div className=" grow-0">
                        <Footer
                            commission={commission}
                            total={total}
                            toBePaidTransactions={payments.filter(
                                (i) => i.isSelected
                            )}
                        />
                    </div>
                </div>
            )}
        </>
    )
}
